export default "__VITE_ASSET__BuCjmpbn__"